import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { CertificateSendType } from 'components/dialogs/send-certificates-choice/send-certificates-choice-dialog';
import { MooringCertificateRecipientType } from 'models/mooring';

export enum MooringCertificateBulkActionType {
  Download = 'download',
  Email = 'email',
}

export type MooringCertificateBulkActionDialogModel = {
  action: MooringCertificateBulkActionType;
  selectedCount: number;
};

export type MooringCertificateBulkActionDialogOutput = {
  action: MooringCertificateBulkActionType;
  sendType: CertificateSendType;
  recipientType?: MooringCertificateRecipientType;
  recipientEmail?: string;
};

@autoinject
export class MooringCertificateBulkActionDialog {
  protected action: MooringCertificateBulkActionType = MooringCertificateBulkActionType.Download;
  protected selectedCount = 0;

  protected sendType: CertificateSendType = CertificateSendType.Zip;
  protected recipientType: MooringCertificateRecipientType = MooringCertificateRecipientType.Me;
  protected recipientEmail = '';
  protected validationMessage = '';

  protected readonly actionTypes = MooringCertificateBulkActionType;
  protected readonly sendTypes = CertificateSendType;
  protected readonly recipientTypes = MooringCertificateRecipientType;

  constructor(private dialogController: DialogController, private t: I18N) {}

  activate(model: MooringCertificateBulkActionDialogModel) {
    if (!model) {
      return;
    }

    this.action = model.action;
    this.selectedCount = model.selectedCount || 0;
  }

  protected confirm() {
    if (this.action === MooringCertificateBulkActionType.Email) {
      if (this.recipientType === MooringCertificateRecipientType.CustomEmail) {
        const email = this.recipientEmail?.trim();

        if (!email) {
          this.validationMessage = this.t.tr('validation.required');
          return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          this.validationMessage = this.t.tr('general.incorrectEmailFormat');
          return;
        }
      }
    }

    this.validationMessage = '';

    this.dialogController.ok({
      action: this.action,
      sendType: this.sendType,
      recipientType: this.action === MooringCertificateBulkActionType.Email ? this.recipientType : undefined,
      recipientEmail: this.action === MooringCertificateBulkActionType.Email ? this.recipientEmail?.trim() : undefined,
    } as MooringCertificateBulkActionDialogOutput);
  }

  protected cancel() {
    this.dialogController.cancel();
  }
}
